export const IMAGE_SLOTS = [
  { slot: "logo", label: "Logo (en-tête & pied de page)" },
  { slot: "home_hero", label: "Accueil — image héro" },
  { slot: "home_map", label: "Accueil — carte / route d'export" },
  { slot: "expertise_courtage", label: "Accueil — carte Courtage" },
  { slot: "expertise_conseil", label: "Accueil — carte Conseil" },
  { slot: "filiere_cacao", label: "Courtage — Cacao" },
  { slot: "filiere_fruits", label: "Courtage — Fruits exotiques" },
  { slot: "filiere_cajou", label: "Courtage — Noix de cajou" },
  { slot: "filiere_cafe", label: "Courtage — Café" },
  { slot: "filiere_caoutchouc", label: "Courtage — Caoutchouc" },
  { slot: "filiere_kola", label: "Courtage — Noix de kola" },
  { slot: "apropos_founder", label: "À propos — portrait du fondateur" },
  { slot: "apropos_igei_logo", label: "À propos — logo IGEI (badge, optionnel — masqué tant qu'aucun logo n'est téléversé)" },
];

export const VIDEO_SLOTS = [
  { slot: "video_cacao", label: "Filière — Cacao (vidéo)" },
  { slot: "video_fruits", label: "Filière — Fruits exotiques (vidéo)" },
  { slot: "video_cajou", label: "Filière — Noix de cajou (vidéo)" },
  { slot: "video_cafe", label: "Filière — Café (vidéo)" },
  { slot: "video_caoutchouc", label: "Filière — Caoutchouc (vidéo)" },
  { slot: "video_kola", label: "Filière — Noix de kola (vidéo)" },
  { slot: "video_sourcing", label: "Process — Sourcing (vidéo)" },
  { slot: "video_qualite", label: "Process — Contrôle qualité (vidéo)" },
  { slot: "video_logistique", label: "Process — Logistique export (vidéo)" },
  { slot: "video_tracabilite", label: "Process — Traçabilité (vidéo)" },
];

export const PAGE_LABELS = {
  global: "Global (navigation, pied de page, contact)",
  home: "Accueil",
  courtage: "Courtage",
  conseil: "Conseil",
  apropos: "À propos",
  contact: "Contact",
  legal: "Mentions légales",
};

// Human-readable field labels, keyed by `${page}.${key}`. Falls back to a
// prettified key when not listed. Ensures fields like "Siège social" are findable.
export const FIELD_LABELS = {
  "legal.hero_kicker": "Sur-titre (bandeau)",
  "legal.title": "Titre de la page",
  "legal.editor_title": "Titre — Éditeur du site",
  "legal.editor_intro": "Éditeur — phrase d'introduction",
  "legal.editor_company": "Éditeur — raison sociale",
  "legal.editor_capital": "Éditeur — capital social",
  "legal.editor_office_label": "Libellé « Siège social »",
  "legal.editor_office": "Siège social (adresse) — à compléter",
  "legal.editor_country": "Éditeur — pays",
  "legal.director_title": "Titre — Directeur de la publication",
  "legal.director_body": "Directeur de la publication",
  "legal.contact_title": "Titre — Contact",
  "legal.contact_email_label": "Libellé « Email »",
  "legal.contact_email": "Email de contact (légal)",
  "legal.contact_phone_label": "Libellé « Téléphone »",
  "legal.contact_phone": "Téléphone (légal) — à compléter",
  "legal.hosting_title": "Titre — Hébergement",
  "legal.hosting_body": "Hébergement — texte",
  "legal.ip_title": "Titre — Propriété intellectuelle",
  "legal.ip_body": "Propriété intellectuelle — texte",
  "legal.data_title": "Titre — Données personnelles",
  "legal.data_body": "Données personnelles — texte",
  "global.company_name": "Nom de l'entreprise",
  "global.location": "Localisation (ville, pays)",
  "global.email": "Email de contact public",
  "global.phone": "Téléphone public — à compléter",
  "global.social_linkedin": "URL LinkedIn (vide = masqué)",
  "global.social_twitter": "URL Twitter/X (vide = masqué)",
  "global.social_facebook": "URL Facebook (vide = masqué)",
  "global.social_instagram": "URL Instagram (vide = masqué)",
  "global.whatsapp_number": "WhatsApp — numéro au format international, chiffres uniquement (ex. 2250747501152). Vide = bouton masqué",
  "global.telegram": "Telegram — nom d'utilisateur ou lien (ex. @agrivoire ou https://t.me/agrivoire). Vide = bouton masqué",
  "global.footer_cookies": "Libellé du lien « Politique de cookies » (pied de page)",
  "contact.response_time": "Délai de réponse (bloc Coordonnées)",
};

export const prettifyKey = (key) =>
  key.replace(/_/g, " ").replace(/\b\w/, (c) => c.toUpperCase());

